import { ExtendedAccountData } from '../types';
import { User } from '../../auth/types';

/**
 * Filter accounts based on user role and allowedAccountIds
 *
 * @param accounts - Array of all accounts
 * @param user - Current authenticated user
 * @returns Filtered array of accounts based on user permissions
 *
 * Filtering rules:
 * - superuser: See ALL accounts
 * - seller: See ALL accounts
 * - admin: See ONLY accounts in allowedAccountIds
 * - user: See ONLY accounts in allowedAccountIds
 */
export const filterAccountsByRole = (
  accounts: ExtendedAccountData[],
  user: User | null
): ExtendedAccountData[] => {
  // If no user, return empty array
  if (!user) {
    return [];
  }

  const userRole = user.role?.toLowerCase();

  // Superusers and sellers see ALL accounts
  if (userRole === 'superuser') {
    return accounts;
  }

  if (!user.allowedAccountIds || user.allowedAccountIds.length === 0) {
    return [];
  }

  return accounts.filter((account) =>
    user.allowedAccountIds!.includes(account.id)
  );
};
